import {positionComponent} from '../../../../../../display/components/common/positionComponent';
import {sizeComponent} from '../../../../../../display/components/common/sizeComponent';
import {feedImageComponent} from '../../../../../../display/components/type/feedImageComponent';

/**
 * Gets the data for a placeholder feed image.
 *
 * @param {string} feedName
 * @param {string} type
 * @param {string} url
 * @param {?number} opacity
 * @returns {function}
 */
export function getPlaceHolderFeedImageData(feedName, type, url, opacity = 1) {
  return ({position, size}) => {
    const defaultSize = 200;
    const positionY = position.y || 0;
    const positionX = position.x || 0;
    const width = size.width || defaultSize;
    const height = size.height || defaultSize;

    return {
      name: feedName,
      setup: {
        ...sizeComponent(width, height),
        ...positionComponent(positionY, positionX),
      },
      ...feedImageComponent(url, {
        type,
        opacity,
      }),
    };
  };
}
